import api from '../../api/_echange'


const state = () => ({
    echanges: [],
})

// getters
const getters = {
    echanges: (state) => {
        return state.echanges
    },


}

// actions
const actions = {
    /**
     * Liste des fournisseurs
     */
    getEchanges({commit}, id) {
        api.getEchange(id).then(
            response => {
                commit('SET_ECHANGES', response)
            }
        )
    },

    async saveEchange({commit}, data) {
        return api.saveEchange(data).then(
            response=> {
                commit('SET_ECHANGES', response)

                return true

            }
        )
    },


}

// mutations
const mutations = {
    
    SET_ECHANGES(state,echanges) {
        state.echanges = echanges
    },
}

export default {
  state,
  getters,
  actions,
  mutations
}
